import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface Props {
    audit_id: string
    form_type: string
    asset: string
    project_name: string
    facility: string
    facility_id: string
    barrier_type: string
    barrier?: string
    sce?: string
    sceName?: string
    barrierTypeName?: string
    barrierName?: string
}

const initialState: Props = {
    audit_id: '',
    form_type: '',
    facility: '',
    barrier_type: '',
    asset: '',
    project_name: '',
    sceName: "",
    barrierTypeName: "",
    barrierName: "",
    facility_id: ""
};

const barrierFormTypeSlice = createSlice({
    name: 'formType',
    initialState,
    reducers: {
        setFormTypeValue: (state, action: PayloadAction<Partial<Props>>) => {
            Object.assign(state, action.payload);
        },
    },
});

export const { setFormTypeValue } = barrierFormTypeSlice.actions;
export default barrierFormTypeSlice.reducer;
